/* Hook encargado de activar / desactivar la sucursal

Autor: 
Fecha: 
*/

import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlBranchActivate } from './connectionData.tsx'

const useBranchActivate = () => {
  const [errorBranchActivate, setErrorBranchActivate] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const branchActivate = async (_id: string, activate: boolean) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlBranchActivate()
      const res = await customPost<{ message: string }>(apiUrl, { _id: _id, activate: activate })
      setErrorBranchActivate(null)

      return res.message
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorBranchActivate(err)
      } else {
        setErrorBranchActivate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorBranchActivate, loading, branchActivate }
}
export default useBranchActivate
